import React from 'react';
import { DICTIONARY_LIST_QUERY } from '../queries';
import { Card } from '@totalsoft/rocket-ui';
import { getListBrowserStore } from '@ts-private/list-browser';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { useMemo } from 'react';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import DictionaryItem from './DictionaryItem';

export const dictionariesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'name',
      caption: 'Dictionaries.Name',
      type: 'text'
    },
    {
      name: 'friendlyName',
      caption: 'Dictionaries.FriendlyName',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'Dictionaries.Name',
      value: 'Name'
    },
    {
      caption: 'Dictionaries.FriendlyName',
      value: 'FriendlyName'
    }
  ],
  pager: {
    orderBy: 'Name',
    direction: 'asc'
  }
});

const DictionaryListBrowser = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: DICTIONARY_LIST_QUERY,
        name: 'dictionaries'
      }
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'name', caption: 'Dictionaries.Name' },
      { name: 'friendlyName', caption: 'Dictionaries.FriendlyName' },
      { name: 'isReadOnly', caption: 'Dictionaries.IsReadOnly', align: 'center' },
      { name: 'actions', caption: 'Actions', width: '120px' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser name='dictionaries-browser' store={dictionariesStore} ItemComponent={DictionaryItem} columns={columns} />
      <ExportModalComponent store={dictionariesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={dictionariesStore} options={fetchingOptions} />
    </Card>
  );
};

export default DictionaryListBrowser;
